module.exports = __webpack_public_path__ + "img/capacity.e445c844.svg";